import { PeopleBlockStatus } from "Bands/types";
import { Checkmark, Info, Mail, Question, Stop } from "shared/assets/icons";
import { ISelectOption } from "shared/components/Form/Fields/select/types";
import { Icon } from "shared/styles";
import { colors } from "shared/styles/constants";
import { IStatus } from "shared/types";

export const peopleBlockStatuses: ISelectOption[] = [
  {
    label: "Attending",
    viewLabel: "Attending",
    value: PeopleBlockStatus.attending,
    icon: Checkmark,
    iconComponent: <Icon as={Checkmark} color={colors.green} />,
    iconStatus: IStatus.success,
    categoryLabel: "All attending members",
  },
  {
    label: "Maybe attending",
    viewLabel: "Maybe attending",
    value: PeopleBlockStatus.maybe_attending,
    icon: Question,
    iconComponent: <Icon as={Question} color={colors.yellow} />,
    iconStatus: IStatus.warning,
    categoryLabel: "All maybe attending members",
  },
  {
    label: "Send RSVP",
    viewLabel: "Pending RSVP",
    value: PeopleBlockStatus.rsvp,
    icon: Mail,
    iconComponent: <Icon as={Mail} color={colors.grey4} />,
    iconStatus: IStatus.default,
    categoryLabel: "All pending RSVP members",
  },
  {
    label: "Not attending",
    viewLabel: "Not attending",
    value: PeopleBlockStatus.not_attending,
    icon: Stop,
    iconComponent: <Icon as={Stop} color={colors.red} />,
    iconStatus: IStatus.error,
  },
  {
    label: "No attendance set",
    viewLabel: "No attendance set",
    value: "none",
    icon: Info,
    iconComponent: <Icon as={Info} color={colors.grey4} />,
    iconStatus: IStatus.default,
  },
];

export const getPeopleBlockStatus = (status: PeopleBlockStatus) =>
  peopleBlockStatuses.find(({ value }) => value === status);
